import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import _ from 'lodash';

import { adminCashExchangesApi } from 'src/api';

import { setAdminCashExchangeErrors, setAdminCashExchangesMeta } from './adminCashExchange.slice';

import { ROUTE } from 'src/constants';
import { dumpCashExchangeData, dumpGetCashExchangesData, normalizeErrorResponse } from 'src/utils';

export const getAdminCashExchanges = createAsyncThunk(
  'adminCasgExchanges/get-admin-cash-exchanges',
  async (data, thunkApi) => {
    try {
      const copiedPayload = _.cloneDeep(data);

      for (const key in copiedPayload) {
        if (!copiedPayload[key]?.length) {
          delete copiedPayload[key];
        }
      }

      const response = await adminCashExchangesApi.getAdminCashExchanges(copiedPayload);

      thunkApi.dispatch(setAdminCashExchangesMeta(response?.meta));

      return dumpGetCashExchangesData(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const createAdminCashExchange = createAsyncThunk(
  'adminCashExchanges/create-admin-cash-exchange',
  async (data, thunkApi) => {
    try {
      const { navigate, payload } = data;

      const copiedPayload = _.cloneDeep(payload);

      delete copiedPayload?.setLanguage;

      for (const key in copiedPayload) {
        if (
          !copiedPayload[key]?.length &&
          typeof copiedPayload[key] !== 'object' &&
          typeof copiedPayload[key] !== 'boolean'
        ) {
          delete copiedPayload[key];
        }
      }

      copiedPayload.active = copiedPayload.active ? 1 : 0;

      const response = await adminCashExchangesApi.createAdminCashExchange(copiedPayload);

      navigate(`${ROUTE.ADMIN.CASH_EXCHANGE.MAIN}/${response?.data}/edit`); // TODO

      toast(response?.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { setLanguage } = data;

      const { response } = error;

      toast(response?.data?.message, { type: 'error', position: 'top-right' });

      const errors = normalizeErrorResponse(response.data.errors);

      if (
        errors?.['descriptions.2.country'] ||
        errors?.['descriptions.2.address'] ||
        errors?.['descriptions.2.city']
      ) {
        setLanguage(2);
      }

      if (
        errors?.['descriptions.1.country'] ||
        errors?.['descriptions.1.address'] ||
        errors?.['descriptions.1.city']
      ) {
        setLanguage(1);
      }

      thunkApi.dispatch(setAdminCashExchangeErrors(errors));
    }
  },
);

export const getAdminEditCashExchange = createAsyncThunk(
  'adminCashExchanges/get-admin-edit-cash-exchange',
  async (data) => {
    try {
      const response = await adminCashExchangesApi.getAdminEditCashExchange(data);

      return dumpCashExchangeData(response?.data);
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateAdminCashExchange = createAsyncThunk(
  'adminCashExchanges/update-admin-cash-exchange',
  async (data, thunkApi) => {
    try {
      const { id, payload } = data; // navigate

      const copiedPayload = _.cloneDeep(payload);

      delete copiedPayload?.setLanguage;

      for (const key in copiedPayload) {
        if (
          !copiedPayload[key]?.length &&
          typeof copiedPayload[key] !== 'object' &&
          typeof copiedPayload[key] !== 'boolean'
        ) {
          delete copiedPayload[key];
        }
      }

      delete copiedPayload?.created_at;
      copiedPayload.active = copiedPayload.active ? 1 : 0;

      const response = await adminCashExchangesApi.updateAdminCashExchange(id, copiedPayload);

      // navigate(ROUTE.ADMIN.EXCHANGE_DIRECTION.MAIN);

      toast(response?.message, { type: 'success', position: 'top-right' });

      return response;
    } catch (error) {
      const { setLanguage } = data;

      const { response } = error;

      toast(response?.data?.message, { type: 'error', position: 'top-right' });

      const errors = normalizeErrorResponse(response.data.errors);

      if (
        errors?.['descriptions.2.country'] ||
        errors?.['descriptions.2.address'] ||
        errors?.['descriptions.2.city']
      ) {
        setLanguage(2);
      }

      if (
        errors?.['descriptions.1.country'] ||
        errors?.['descriptions.1.address'] ||
        errors?.['descriptions.1.city']
      ) {
        setLanguage(1);
      }

      thunkApi.dispatch(setAdminCashExchangeErrors(errors));
    }
  },
);
